import { render, staticRenderFns } from "./SecondGraduationSendDocumentForm.vue?vue&type=template&id=c3e51fee&scoped=true&"
import script from "./SecondGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
export * from "./SecondGraduationSendDocumentForm.vue?vue&type=script&lang=ts&"
import style0 from "./SecondGraduationSendDocumentForm.vue?vue&type=style&index=0&id=c3e51fee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e51fee",
  null
  
)

export default component.exports